import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<section\n  class=\"cLIB--board eLib--board\"\n  {{did-insert this.setMediaNavigation}}\n  {{did-update\n    this.setMediaNavigation\n    this.showingStarredMedia\n    this.sortedStarredMediaItems\n    this.orderedMatchingMediaItems\n  }}\n  {{will-destroy this.clearMediaNavigation}}\n>\n  <Schedule::SideLibrary::Header\n    @canScheduleTextOnly={{this.canScheduleTextOnly}}\n    @displayStarredMedia={{this.displayStarredMedia}}\n    @hideMediaFilter={{this.hideMediaFilter}}\n    @hideStarredMedia={{this.hideStarredMedia}}\n    @onDragEnd={{this.onDragEnd}}\n    @onDragStart={{this.onDragStart}}\n    @scheduleMultiImagePost={{@scheduleMultiImagePost}}\n    @selectedAssets={{@selectedAssets}}\n    @showCreatePostButton={{this.showCreatePostButton}}\n    @showingMediaFilter={{this.showingMediaFilter}}\n    @showingStarredMedia={{this.showingStarredMedia}}\n    @toggleShowMediaFilter={{this.toggleShowMediaFilter}}\n  />\n  {{! Side Library Scrollable Area}}\n  <div\n    class={{concat-classes\n      \"cLIB--scrollContainer\"\n      \"at--pirateOnboardingV2__sideLibrary at--libChecklist__sideLibrary at--onboardingChecklist__sideLibrary--de at--onboardingChecklist__sideLibrary--fr at--schedulingOverviewV1__sideLibrary at--holisticOnSchV1__sideLibrary--postTypes at--holisticOnSchV1__sideLibrary--lib at--holisticOnSchV1__sideLibrary--tagging\"\n      (if\n        this.isEmptyOfValidMediaItems\n        \"at--holisticLibrary__sideLibrary--postBuilderNoMedia at--holisticLibrary__sideLibrary--uploadMediaSchedulePostV1\"\n      )\n    }}\n    {{perfect-scroll this.SCROLLBAR_ID}}\n  >\n    {{! Currently applied filters. Does not appear while showing starred media }}\n    {{#if (and this.hasActiveFilters (not this.showingStarredMedia))}}\n      <Schedule::ActiveFilters\n        @clearAllFilters={{this.clearAllFilters}}\n        @clearSearchString={{this.clearSearchString}}\n        @filterSocialProfiles={{this.filterSocialProfiles}}\n        @isAllMediaTypes={{this.isAllMediaTypes}}\n        @isAllUsageMedia={{this.isAllUsageMedia}}\n        @isSearchingMediaNotes={{this.isSearchingMediaNotes}}\n        @isSearchingSocialProfiles={{this.isSearchingSocialProfiles}}\n        @mediaNotesSearchString={{this.mediaNotesSearchString}}\n        @mediaTypeFilter={{this.mediaTypeFilter}}\n        @queryLabels={{this.queryLabels}}\n        @removeQueryLabel={{this.removeQueryLabel}}\n        @removeQuerySocialProfile={{this.removeQuerySocialProfile}}\n        @setMediaTypeFilter={{this.setMediaTypeFilter}}\n        @setUsedUnused={{this.setUsedUnused}}\n        @usedUnused={{this.usedUnused}}\n      />\n    {{/if}}\n    {{#if this.isEmptyOfValidMediaItems}}\n      <Schedule::SideLibrary::Empty />\n    {{else if this.showingStarredMedia}}\n      <Schedule::SideLibrary::StarredMediaBoard\n        @addSelection={{@addSelection}}\n        @canDrag={{this.canDrag}}\n        @enableAutoSchedule={{@enableAutoSchedule}}\n        @enableMultiSelect={{this.enableMultiSelect}}\n        @isDragging={{@isDragging}}\n        @onDragEnd={{this.onDragEnd}}\n        @onDragStart={{this.onDragStart}}\n        @openMediaItem={{@openMediaItem}}\n        @removeSelection={{@removeSelection}}\n        @selectedAssets={{@selectedAssets}}\n        @starredMedia={{@starredMedia}}\n      />\n    {{else}}\n      {{#if this.firstQueryLoad}}\n        <div class=\"o--loading\"></div>\n      {{else}}\n        <Schedule::SideLibrary::MediaBoard\n          @addSelection={{@addSelection}}\n          @canDrag={{this.canDrag}}\n          @canLoadMore={{this.canLoadMore}}\n          @enableAutoSchedule={{@enableAutoSchedule}}\n          @enableMultiSelect={{this.enableMultiSelect}}\n          @isDragging={{@isDragging}}\n          @isFilteredEmpty={{this.isFilteredEmpty}}\n          @isStories={{this.isStories}}\n          @isUnusedEmpty={{this.isUnusedEmpty}}\n          @isUsedEmpty={{this.isUsedEmpty}}\n          @loadMore={{this.loadMore}}\n          @onDragEnd={{this.onDragEnd}}\n          @onDragStart={{this.onDragStart}}\n          @openMediaItem={{@openMediaItem}}\n          @orderedMatchingMediaItems={{this.orderedMatchingMediaItems}}\n          @queryLoadingMore={{this.queryLoadingMore}}\n          @removeSelection={{@removeSelection}}\n          @selectedAssets={{@selectedAssets}}\n          @showUnused={{this.showUnused}}\n        />\n      {{/if}}\n    {{/if}}\n  </div>\n  {{! End of Side Library Scrollable Area }}\n\n  {{! Auto-schedule bottom bar and calendar top bar }}\n  {{#if this.showMultiSelectBar}}\n    <Schedule::SideLibrary::MultiSelectBar\n      @autoScheduleButtonText={{this.autoScheduleButtonText}}\n      @deselectAll={{@deselectAll}}\n      @enableAutoScheduleButton={{this.enableAutoScheduleButton}}\n      @enableCarouselPostButton={{this.enableCarouselPostButton}}\n      @multiSelectButton={{this.multiSelectButton}}\n      @scheduleMultiImagePost={{@scheduleMultiImagePost}}\n      @selectedAssets={{@selectedAssets}}\n    />\n  {{/if}}\n</section>\n\n{{! Media Filter Overlay }}\n<Schedule::SideLibrary::MediaFilterOverlay\n  @hideMediaFilter={{this.hideMediaFilter}}\n  @showingMediaFilter={{this.showingMediaFilter}}\n/>\n\n{{! Media Filter Container }}\n<Schedule::SideLibrary::MediaFilterContainer\n  @addQueryLabel={{this.addQueryLabel}}\n  @addQuerySocialProfile={{this.addQuerySocialProfile}}\n  @clearQuerySocialProfile={{this.clearQuerySocialProfile}}\n  @clearSearchString={{this.clearSearchString}}\n  @group={{this.currentGroup}}\n  @hasSearchTerms={{this.hasSearchTerms}}\n  @mediaTypeFilter={{this.mediaTypeFilter}}\n  @queryLabelIds={{this.queryLabelIds}}\n  @querySocialProfileIds={{this.querySocialProfileIds}}\n  @removeQueryLabel={{this.removeQueryLabel}}\n  @removeQuerySocialProfile={{this.removeQuerySocialProfile}}\n  @searchMediaNotes={{this.searchMediaNotes}}\n  @searchString={{this.searchString}}\n  @setMediaTypeFilter={{this.setMediaTypeFilter}}\n  @setUsedUnused={{this.setUsedUnused}}\n  @showingMediaFilter={{this.showingMediaFilter}}\n  @usedUnused={{this.usedUnused}}\n/>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<section\n  class=\"cLIB--board eLib--board\"\n  {{did-insert this.setMediaNavigation}}\n  {{did-update\n    this.setMediaNavigation\n    this.showingStarredMedia\n    this.sortedStarredMediaItems\n    this.orderedMatchingMediaItems\n  }}\n  {{will-destroy this.clearMediaNavigation}}\n>\n  <Schedule::SideLibrary::Header\n    @canScheduleTextOnly={{this.canScheduleTextOnly}}\n    @displayStarredMedia={{this.displayStarredMedia}}\n    @hideMediaFilter={{this.hideMediaFilter}}\n    @hideStarredMedia={{this.hideStarredMedia}}\n    @onDragEnd={{this.onDragEnd}}\n    @onDragStart={{this.onDragStart}}\n    @scheduleMultiImagePost={{@scheduleMultiImagePost}}\n    @selectedAssets={{@selectedAssets}}\n    @showCreatePostButton={{this.showCreatePostButton}}\n    @showingMediaFilter={{this.showingMediaFilter}}\n    @showingStarredMedia={{this.showingStarredMedia}}\n    @toggleShowMediaFilter={{this.toggleShowMediaFilter}}\n  />\n  {{! Side Library Scrollable Area}}\n  <div\n    class={{concat-classes\n      \"cLIB--scrollContainer\"\n      \"at--pirateOnboardingV2__sideLibrary at--libChecklist__sideLibrary at--onboardingChecklist__sideLibrary--de at--onboardingChecklist__sideLibrary--fr at--schedulingOverviewV1__sideLibrary at--holisticOnSchV1__sideLibrary--postTypes at--holisticOnSchV1__sideLibrary--lib at--holisticOnSchV1__sideLibrary--tagging\"\n      (if\n        this.isEmptyOfValidMediaItems\n        \"at--holisticLibrary__sideLibrary--postBuilderNoMedia at--holisticLibrary__sideLibrary--uploadMediaSchedulePostV1\"\n      )\n    }}\n    {{perfect-scroll this.SCROLLBAR_ID}}\n  >\n    {{! Currently applied filters. Does not appear while showing starred media }}\n    {{#if (and this.hasActiveFilters (not this.showingStarredMedia))}}\n      <Schedule::ActiveFilters\n        @clearAllFilters={{this.clearAllFilters}}\n        @clearSearchString={{this.clearSearchString}}\n        @filterSocialProfiles={{this.filterSocialProfiles}}\n        @isAllMediaTypes={{this.isAllMediaTypes}}\n        @isAllUsageMedia={{this.isAllUsageMedia}}\n        @isSearchingMediaNotes={{this.isSearchingMediaNotes}}\n        @isSearchingSocialProfiles={{this.isSearchingSocialProfiles}}\n        @mediaNotesSearchString={{this.mediaNotesSearchString}}\n        @mediaTypeFilter={{this.mediaTypeFilter}}\n        @queryLabels={{this.queryLabels}}\n        @removeQueryLabel={{this.removeQueryLabel}}\n        @removeQuerySocialProfile={{this.removeQuerySocialProfile}}\n        @setMediaTypeFilter={{this.setMediaTypeFilter}}\n        @setUsedUnused={{this.setUsedUnused}}\n        @usedUnused={{this.usedUnused}}\n      />\n    {{/if}}\n    {{#if this.isEmptyOfValidMediaItems}}\n      <Schedule::SideLibrary::Empty />\n    {{else if this.showingStarredMedia}}\n      <Schedule::SideLibrary::StarredMediaBoard\n        @addSelection={{@addSelection}}\n        @canDrag={{this.canDrag}}\n        @enableAutoSchedule={{@enableAutoSchedule}}\n        @enableMultiSelect={{this.enableMultiSelect}}\n        @isDragging={{@isDragging}}\n        @onDragEnd={{this.onDragEnd}}\n        @onDragStart={{this.onDragStart}}\n        @openMediaItem={{@openMediaItem}}\n        @removeSelection={{@removeSelection}}\n        @selectedAssets={{@selectedAssets}}\n        @starredMedia={{@starredMedia}}\n      />\n    {{else}}\n      {{#if this.firstQueryLoad}}\n        <div class=\"o--loading\"></div>\n      {{else}}\n        <Schedule::SideLibrary::MediaBoard\n          @addSelection={{@addSelection}}\n          @canDrag={{this.canDrag}}\n          @canLoadMore={{this.canLoadMore}}\n          @enableAutoSchedule={{@enableAutoSchedule}}\n          @enableMultiSelect={{this.enableMultiSelect}}\n          @isDragging={{@isDragging}}\n          @isFilteredEmpty={{this.isFilteredEmpty}}\n          @isStories={{this.isStories}}\n          @isUnusedEmpty={{this.isUnusedEmpty}}\n          @isUsedEmpty={{this.isUsedEmpty}}\n          @loadMore={{this.loadMore}}\n          @onDragEnd={{this.onDragEnd}}\n          @onDragStart={{this.onDragStart}}\n          @openMediaItem={{@openMediaItem}}\n          @orderedMatchingMediaItems={{this.orderedMatchingMediaItems}}\n          @queryLoadingMore={{this.queryLoadingMore}}\n          @removeSelection={{@removeSelection}}\n          @selectedAssets={{@selectedAssets}}\n          @showUnused={{this.showUnused}}\n        />\n      {{/if}}\n    {{/if}}\n  </div>\n  {{! End of Side Library Scrollable Area }}\n\n  {{! Auto-schedule bottom bar and calendar top bar }}\n  {{#if this.showMultiSelectBar}}\n    <Schedule::SideLibrary::MultiSelectBar\n      @autoScheduleButtonText={{this.autoScheduleButtonText}}\n      @deselectAll={{@deselectAll}}\n      @enableAutoScheduleButton={{this.enableAutoScheduleButton}}\n      @enableCarouselPostButton={{this.enableCarouselPostButton}}\n      @multiSelectButton={{this.multiSelectButton}}\n      @scheduleMultiImagePost={{@scheduleMultiImagePost}}\n      @selectedAssets={{@selectedAssets}}\n    />\n  {{/if}}\n</section>\n\n{{! Media Filter Overlay }}\n<Schedule::SideLibrary::MediaFilterOverlay\n  @hideMediaFilter={{this.hideMediaFilter}}\n  @showingMediaFilter={{this.showingMediaFilter}}\n/>\n\n{{! Media Filter Container }}\n<Schedule::SideLibrary::MediaFilterContainer\n  @addQueryLabel={{this.addQueryLabel}}\n  @addQuerySocialProfile={{this.addQuerySocialProfile}}\n  @clearQuerySocialProfile={{this.clearQuerySocialProfile}}\n  @clearSearchString={{this.clearSearchString}}\n  @group={{this.currentGroup}}\n  @hasSearchTerms={{this.hasSearchTerms}}\n  @mediaTypeFilter={{this.mediaTypeFilter}}\n  @queryLabelIds={{this.queryLabelIds}}\n  @querySocialProfileIds={{this.querySocialProfileIds}}\n  @removeQueryLabel={{this.removeQueryLabel}}\n  @removeQuerySocialProfile={{this.removeQuerySocialProfile}}\n  @searchMediaNotes={{this.searchMediaNotes}}\n  @searchString={{this.searchString}}\n  @setMediaTypeFilter={{this.setMediaTypeFilter}}\n  @setUsedUnused={{this.setUsedUnused}}\n  @showingMediaFilter={{this.showingMediaFilter}}\n  @usedUnused={{this.usedUnused}}\n/>","moduleName":"later/components/schedule/side-library/index.hbs","parseOptions":{"srcName":"later/components/schedule/side-library/index.hbs"}});
import { computed, action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone, isEmpty, isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isString } from 'lodash';
import { TrackedArray } from 'tracked-built-ins';

import { SegmentEventTypes } from 'later/utils/constants/segment-events';
import { queryListToString, buildQueryArray } from 'later/utils/format-query';
import uuid from 'shared/utils/uuid';

import type IntlService from 'ember-intl/services/intl';
import type GroupModel from 'later/models/group';
import type LabelModel from 'later/models/label';
import type MediaItemModel from 'later/models/media-item';
import type SocialProfileModel from 'later/models/social-profile';
import type AuthService from 'later/services/auth';
import type { QueryWithFilterParams } from 'later/services/media-item-query';
import type MediaItemQueryService from 'later/services/media-item-query';
import type MediaNavigationService from 'later/services/media-navigation';
import type OnboardingService from 'later/services/onboarding';
import type PerfectScrollService from 'later/services/perfect-scroll';
import type QueryPersistenceService from 'later/services/query-persistence';
import type ScheduleService from 'later/services/schedule';
import type SegmentService from 'later/services/segment';
import type UploadBusService from 'later/services/upload-bus';
import type UserRoleService from 'later/services/user-role';

interface SideLibraryComponentArgs {
  addSelection: (mediaItem: MediaItemModel) => void;
  assignDropData: (draggedElement: EventTarget | null, event: Event) => void;
  canCreateFirstTimeSlot: boolean;
  deselectAll: () => void;
  droppedMediaItems: (droppedData: string) => void;
  enableAutoSchedule: boolean;
  isDragging: boolean;
  isViewingMultiple: boolean;
  mediaItems: MediaItemModel[];
  openMediaItem: (mediaItem: MediaItemModel) => void;
  removeSelection: (mediaItem: MediaItemModel) => void;
  scheduleMultiImagePost: (mediaItems: MediaItemModel[], location: string) => void;
  selectedAssets: MediaItemModel[];
  selectedAssetsAction: () => void;
  setIsDragging: (isDragging: boolean) => void;
  showStarredMedia: boolean;
  starredMedia: MediaItemModel[];
}

export default class SideLibraryComponent extends Component<SideLibraryComponentArgs> {
  @service declare auth: AuthService;
  @service declare intl: IntlService;
  @service declare mediaItemQuery: MediaItemQueryService;
  @service declare mediaNavigation: MediaNavigationService;
  @service declare onboarding: OnboardingService;
  @service declare segment: SegmentService;
  @service declare uploadBus: UploadBusService;
  @service declare queryPersistence: QueryPersistenceService;
  @service declare perfectScroll: PerfectScrollService;
  @service declare schedule: ScheduleService;
  @service declare userRole: UserRoleService;

  @tracked showingMediaFilter = false;
  @tracked starredMediaSelected = false;
  @tracked declare usedUnused: string;
  @tracked declare mediaTypeFilter: string;
  @tracked declare searchString: string;
  @tracked declare mediaNotesSearchString: string;
  @tracked declare queryLabelIds: TrackedArray<number>;
  @tracked declare querySocialProfileIds: TrackedArray<number>;

  SCROLLBAR_ID = uuid();
  QUERY_MEDIA_LIMIT = 30;

  constructor(owner: unknown, args: SideLibraryComponentArgs) {
    super(owner, args);

    if (this.args.showStarredMedia) {
      this.displayStarredMedia();
    }

    this.mediaNavigation.setNarrowArrows(true);
    this.uploadBus.on('didBeginUpload', this, '_handleDidBeginUpload');

    this.mediaNotesSearchString = this.queryPersistence.getSearchString('side-library', '');
    this.mediaTypeFilter = this.queryPersistence.getMediaTypeFilter('side-library', '');
    this.queryLabelIds = this.queryPersistence.getLabelIds('side-library');
    this.querySocialProfileIds = this.queryPersistence.getSocialProfileIds('side-library');
    this.searchString = this.queryPersistence.getSearchString('side-library', '');
    this.usedUnused = this.queryPersistence.getUsedUnused('side-library', 'unused');
  }

  get canCreateTimeSlotsOnPreview(): boolean {
    return this.args.canCreateFirstTimeSlot && this.isPreviewGrid;
  }

  get canDragPreview(): boolean {
    return this.args.enableAutoSchedule || this.canCreateTimeSlotsOnPreview;
  }

  get hasMatchingMediaItems(): boolean {
    return !isEmpty(this.matchingMediaItems);
  }

  get hasSearchString(): boolean {
    return !isEmpty(this.searchString);
  }

  get hasSelectedMedia(): boolean {
    return this.numSelectedAssets > 0;
  }

  get hasValidMediaItems(): boolean {
    return !isEmpty(this.validMediaItems);
  }

  get isAllMedia(): boolean {
    return this.isAllUsageMedia && this.isAllMediaTypes;
  }

  get isAllMediaTypes(): boolean {
    return isEmpty(this.mediaTypeFilter);
  }

  get isAllUsageMedia(): boolean {
    return isEmpty(this.usedUnused);
  }

  get isCalendar(): boolean {
    return this.schedule.sideLibraryBehavior === 'calendar';
  }

  get isEmptyOfValidMediaItems(): boolean {
    return isEmpty(this.validMediaItems);
  }

  get isPreviewGrid(): boolean {
    return this.schedule.sideLibraryBehavior === 'preview';
  }

  get isList(): boolean {
    return this.schedule.sideLibraryBehavior === 'list';
  }

  get isSearchingLabels(): boolean {
    return !isEmpty(this.queryLabelIds);
  }

  get isSearchingMediaNotes(): boolean {
    return !isEmpty(this.mediaNotesSearchString);
  }

  get isSearchingSocialProfiles(): boolean {
    return !isEmpty(this.querySocialProfileIds);
  }

  get isStories(): boolean {
    return this.schedule.sideLibraryBehavior === 'stories';
  }

  get numSelectedAssets(): number {
    return this.args.selectedAssets.length;
  }

  get orderedMatchingMediaItems(): MediaItemModel[] {
    return this.matchingMediaItems.sortBy('createdTime').reverse();
  }

  get showingStarredMedia(): boolean {
    return this.starredMediaSelected;
  }

  get sortedStarredMediaItems(): MediaItemModel[] {
    return this.args.starredMedia.sortBy('createdTime');
  }

  get hasCompletedOnboarding(): boolean {
    return !this.onboarding.hasNotCompletedOnboarding;
  }

  get showCreatePostButton(): boolean {
    const hasSocialProfile = isPresent(this.auth.currentGroup.socialProfiles);
    const notStoriesOrPreview = !this.isStories && !this.isPreviewGrid;
    return notStoriesOrPreview && hasSocialProfile && this.hasCompletedOnboarding;
  }

  get canInstagramStories(): boolean | undefined {
    return this.auth.currentAccount.canInstagramStories;
  }

  get currentGroup(): GroupModel {
    return this.auth.currentGroup;
  }

  get canScheduleTextOnly(): boolean {
    return !this.auth.currentAccount.isOnLegacyPlan && !this.hasNoSocialProfile;
  }

  get hasNoSocialProfile(): boolean {
    return isEmpty(this.currentGroup.get('socialProfiles'));
  }

  get enableAutoScheduleButton(): boolean {
    return this.args.enableAutoSchedule && !this.hasNoSocialProfile && !this.userRole.currentUser.needsApproval;
  }

  // Note: @computed required here as mediaItemQuery.isLoading is not tracked
  @computed('mediaItemQuery.{queryListQuery,queryListStartQuery}')
  get queryLoading(): boolean {
    return this.mediaItemQuery.isLoading(this.currentQueryListString);
  }

  // Note: @computed required here as mediaItemQuery.isLoadingMore is not tracked
  @computed('mediaItemQuery.{queryListQuery,queryListStartQuery}')
  get queryLoadingMore(): boolean {
    return this.mediaItemQuery.isLoadingMore(this.currentQueryListString);
  }

  get showingUnused(): boolean {
    if (this.starredMediaSelected) {
      return false;
    }
    return this.usedUnused === 'unused';
  }

  get showingUsed(): boolean {
    if (this.starredMediaSelected) {
      return false;
    }
    return this.usedUnused === 'used';
  }

  get canDrag(): boolean {
    if (this.isCalendar) {
      return true;
    } else if (this.isPreviewGrid) {
      return this.canDragPreview;
    } else if (this.isStories) {
      return Boolean(this.canInstagramStories);
    } else if (this.isList) {
      return true;
    }
    return false;
  }

  get hasActiveFilters(): boolean {
    return !this.isAllMedia || this.isSearchingLabels || this.isSearchingSocialProfiles || this.isSearchingMediaNotes;
  }

  get filterSocialProfiles(): SocialProfileModel[] {
    return this.currentGroup
      .get('socialProfiles')
      .filter((socialProfile) => this.querySocialProfileIds.includes(parseInt(socialProfile.get('id'))))
      .sortBy('displayNickname');
  }

  get hasSearchTerms(): boolean {
    return this.hasSearchString || this.isSearchingMediaNotes;
  }

  get currentQueryListString(): string {
    const queryArray = buildQueryArray(
      this.queryLabelIds,
      null,
      this.mediaNotesSearchString,
      this.usedUnused,
      this.mediaTypeFilter,
      this.querySocialProfileIds,
      this.currentGroup.id
    );
    return queryListToString(queryArray);
  }

  get queryListParams(): QueryWithFilterParams {
    return {
      groupId: this.currentGroup.id,
      labelIds: this.queryLabelIds,
      searchString: this.mediaNotesSearchString,
      socialProfileIds: this.querySocialProfileIds,
      mediaTypeFilter: this.mediaTypeFilter,
      usedUnused: this.usedUnused,
      limit: this.QUERY_MEDIA_LIMIT
    };
  }

  // Note: @computed required here as mediaItemQuery.isCompleted is not tracked
  @computed('mediaItemQuery.queryListQuery')
  get canLoadMore(): boolean {
    return !this.mediaItemQuery.isCompleted(this.currentQueryListString);
  }

  get enableMultiSelect(): boolean {
    if (this.isCalendar || this.isStories || this.isList) {
      return true;
    } else if (this.isPreviewGrid) {
      return this.args.enableAutoSchedule;
    }
    return false;
  }

  get showMultiSelectBar(): boolean {
    if (this.isCalendar || this.isList) {
      return this.showMultiSelectBarCalendar;
    } else if (this.isPreviewGrid) {
      return this.showMultiSelectBarPreview;
    }
    return false;
  }

  get showMultiSelectBarCalendar(): boolean {
    if (this.enableMultiSelect && this.hasSelectedMedia) {
      if (this.enableAutoScheduleButton) {
        return true;
      }
      return this.enableCarouselPostButton; //because carousel button only appears when > 1 media selected
    }
    return false;
  }

  get showMultiSelectBarPreview(): boolean {
    return this.args.enableAutoSchedule && this.hasSelectedMedia && this.enableAutoScheduleButton;
  }

  get enableCarouselPostButton(): boolean {
    const isSupportedView = this.isCalendar || this.isList;
    return isSupportedView && this.numSelectedAssets > 1 && !this.hasNoSocialProfile;
  }

  get autoScheduleButtonText(): string {
    if (this.isCalendar || this.isList) {
      return this.intl.t('calendar.side_library.auto_schedule');
    } else if (this.isPreviewGrid) {
      return this.intl.t('calendar.side_library.add_to_preview');
    }
    return '';
  }

  get validMediaItems(): MediaItemModel[] {
    if (isNone(this.args.mediaItems)) {
      return new TrackedArray([]);
    }
    return this.args.mediaItems.filterBy('active', true).filterBy('approved', true);
  }

  get matchingMediaItems(): MediaItemModel[] {
    const mediaItems = this.validMediaItems;
    if (isNone(this.currentQueryListString)) {
      return mediaItems;
    }
    return this.mediaItemQuery.filterMediaItems(mediaItems, this.queryListParams);
  }

  get isFilteredEmpty(): boolean {
    return this.hasActiveFilters && !this.hasMatchingMediaItems;
  }

  get isUnusedEmpty(): boolean {
    return !this.hasValidMediaItems && this.isFilteredEmpty && this.showingUnused;
  }

  get isUsedEmpty(): boolean {
    return !this.hasValidMediaItems && this.isFilteredEmpty && this.showingUsed;
  }

  get firstQueryLoad(): boolean {
    return this.queryLoading && !this.queryLoadingMore;
  }

  get queryLabels(): LabelModel[] {
    if (isEmpty(this.currentGroup.get('labels')) || isEmpty(this.queryLabelIds)) {
      return new TrackedArray([]);
    }
    return this.currentGroup.get('labels').filter((label) => this.queryLabelIds.includes(parseInt(label.get('id'))));
  }

  @action
  showUnused(): void {
    this.usedUnused = 'unused';
    this.starredMediaSelected = false;
    this.args.deselectAll();
    this.queryPersistence.setUsedUnused('side-library', 'unused');
    this.#querySideLibrary();
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  @action
  displayStarredMedia(): void {
    this.hideMediaFilter();
    this.starredMediaSelected = true;
    this.args.deselectAll();
    this.segment.track(SegmentEventTypes.ViewedStarredMedia, {
      group_id: this.currentGroup.id,
      location: 'calendar'
    });
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  @action
  hideStarredMedia(): void {
    this.starredMediaSelected = false;
    this.args.deselectAll();
    this.#querySideLibrary();
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  @action
  loadMore(): void {
    this.#querySideLibrary({ loadMore: true });
  }

  @action
  multiSelectButton(): void {
    this.args.selectedAssetsAction();
  }

  @action
  onDragStart(dragEvent: DragEvent): void {
    this.hideMediaFilter();
    this.args.assignDropData(dragEvent.target, dragEvent);
    this.args.setIsDragging(true);
  }

  @action
  onDragEnd(dragEvent: DragEvent): void {
    const draggedElement = dragEvent.target as Element;
    if (draggedElement?.getAttribute('drop-data')) {
      draggedElement.removeAttribute('drop-data');
    }

    this.schedule.isDraggingEmptyPost = false;
    this.args.setIsDragging(false);
  }

  @action
  hideMediaFilter(): void {
    this.showingMediaFilter = false;
  }

  @action
  addQueryLabel(labelId: string): void {
    this.queryLabelIds.addObject(parseInt(labelId));
    this.queryPersistence.setLabelIds('side-library', this.queryLabelIds);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  removeQueryLabel(labelId: string): void {
    this.queryLabelIds.removeObject(parseInt(labelId));
    this.queryPersistence.setLabelIds('side-library', this.queryLabelIds);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  clearQuerySocialProfile(): void {
    this.querySocialProfileIds.clear();
    this.queryPersistence.setSocialProfileIds('side-library', this.querySocialProfileIds);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  addQuerySocialProfile(socialProfileId: string): void {
    const parsedSocialProfileId = parseInt(socialProfileId);
    this.querySocialProfileIds.clear();
    this.querySocialProfileIds.addObject(parsedSocialProfileId);
    this.queryPersistence.setSocialProfileIds('side-library', this.querySocialProfileIds);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  removeQuerySocialProfile(socialProfileId: string): void {
    const parsedSocialProfileId = parseInt(socialProfileId);
    this.querySocialProfileIds.removeObject(parsedSocialProfileId);
    this.queryPersistence.setSocialProfileIds('side-library', this.querySocialProfileIds);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  setUsedUnused({ value }: { value: string }): void {
    this.usedUnused = value;
    this.starredMediaSelected = false;
    this.queryPersistence.setUsedUnused('side-library', value);
    this.args.deselectAll();

    if (isString(value) && isEmpty(value)) {
      this.querySocialProfileIds.clear();
      this.queryPersistence.setSocialProfileIds('side-library', this.querySocialProfileIds);
    }

    this.#querySideLibrary();
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  @action
  setMediaTypeFilter({ value }: { value: string }): void {
    this.mediaTypeFilter = value;
    this.starredMediaSelected = false;
    this.queryPersistence.setMediaTypeFilter('side-library', value);
    this.args.deselectAll();
    this.#querySideLibrary();
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  @action
  searchMediaNotes(): void {
    this.mediaNotesSearchString = this.searchString;
    this.queryPersistence.setSearchString('side-library', this.searchString);
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  clearSearchString(): void {
    this.mediaNotesSearchString = '';
    this.searchString = '';
    this.queryPersistence.setSearchString('side-library', '');
    this.args.deselectAll();
    this.#querySideLibrary();
  }

  @action
  clearAllFilters(): void {
    this.#clearMediaFilters();
    this.#querySideLibrary();
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
    this.args.deselectAll();
  }

  @action
  setMediaNavigation(): void {
    if (this.showingStarredMedia) {
      this.mediaNavigation.setMediaItems(this.sortedStarredMediaItems, { sideLibrary: true });
    } else {
      this.mediaNavigation.setMediaItems(this.orderedMatchingMediaItems, { sideLibrary: true });
    }
  }

  @action
  clearMediaNavigation(): void {
    this.mediaNavigation.setNarrowArrows(false);
    this.mediaNavigation.clearMediaItems({ sideLibrary: true });
    this.uploadBus.off('didBeginUpload', this, '_handleDidBeginUpload');
  }

  @action
  toggleShowMediaFilter(): void {
    this.showingMediaFilter = !this.showingMediaFilter;
  }

  _handleDidBeginUpload(): void {
    this.args.deselectAll();
    this.#clearMediaFilters({ clearUsedUnused: false });

    this.#querySideLibrary({ trackEvent: false });
    this.perfectScroll.scrollToTop(this.SCROLLBAR_ID);
  }

  #clearMediaFilters(options = { clearUsedUnused: true }): void {
    this.queryLabelIds.clear();
    this.querySocialProfileIds.clear();
    this.mediaNotesSearchString = '';
    this.searchString = '';
    this.mediaTypeFilter = '';
    this.starredMediaSelected = false;
    this.queryPersistence.clear('side-library');
    if (options.clearUsedUnused) {
      this.usedUnused = '';
    }
  }

  #querySideLibrary(opts?: { loadMore?: boolean; trackEvent?: boolean }): void {
    const params = Object.assign({}, this.queryListParams);
    params.page = 'side-library';
    params.limit = this.QUERY_MEDIA_LIMIT;

    if (opts) {
      if ('loadMore' in opts) {
        params.loadMore = opts.loadMore;
      }

      if ('trackEvent' in opts) {
        params.trackEvent = opts.trackEvent;
      }
    }

    this.mediaItemQuery.queryWithFilters(params);
  }
}
